import { gql } from "@apollo/client";

export const GET_CPU_RAM_ANALYSIS = gql`
  query GetCpuRamAnalysis($vmId: ID!) {
    getCpuRamAnalysis(vmId: $vmId) {
      id
      vmId
      vmName
      cpuHasPattern
      cpuPatternDescription
      cpuPeakDay
      cpuPeakHour
      cpuSeverity
      ramHasPattern
      ramPatternDescription
      ramSeverity
      anomalyDetected
      anomalyDetails
      recommendationAction
      recommendationSuggestion
      createdAt
    }
  }
`;

export const ANALYZE_ALL_VMS_CPU_RAM = gql`
  mutation AnalyzeAllVmsCpuRam {
    analyzeAllVmsCpuRam
  }
`;